import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  HireAndroidRigorous,
  HireAndroidBoost,
  HireAndroidSpeedy,
  HireAndroidFlexible,
  HireAndroidCost,
  HireAndroidSupport,
} from "../../../app-constants";
import { Link } from "gatsby";

function Whychoosespeeech() {
  return (
    <section className="voice_services why_choose_speech p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={7}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>Why Choose Our Android Developers</h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {HireAndroidRigorous}
                    </div>
                    <div className="voice_service_head">
                      <h5>Rigorous Vetting Process</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Engage with Android developers who have undergone thorough
                      technical and communication assessments, ensuring
                      readiness to meet your project needs effectively.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{HireAndroidBoost}</div>
                    <div className="voice_service_head">
                      <h5>Boost Operational Efficiency</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Improved operational efficiency reduces costs and enhances
                      productivity, contributing to better business performance.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{HireAndroidSpeedy}</div>
                    <div className="voice_service_head">
                      <h5>Speedy Hiring</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Reduce hiring time significantly with our streamlined
                      process, enabling you to hire top Android developers
                      within 48 hours for urgent projects.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {HireAndroidFlexible}
                    </div>
                    <div className="voice_service_head">
                      <h5>Flexible Engagement Models</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Choose from full-time, part-time, or project-based hiring,
                      allowing you to scale your development team as needed.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">{HireAndroidCost}</div>
                    <div className="voice_service_head">
                      <h5>Cost-Effective Solutions</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Benefit from competitive pricing without compromising
                      quality. Leverage offshore development for cost savings
                      while maintaining high standards.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_svg">
                      {HireAndroidSupport}
                    </div>
                    <div className="voice_service_head">
                      <h5>End-to-End Support</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      From initial consultation to post-deployment, our
                      dedicated team ensures fail-safe, future-proof Android
                      apps. Address technical challenges promptly to keep your
                      project on track.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-5"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="Hire iOS Developers"
            >
              Connect with Our Android Developers
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
